import { motion } from 'framer-motion';

const brands = [
  'Northwind',
  'Lumen',
  'Atlas Co.',
  'Nimbus',
  'Helios',
  'Verge',
  'Quartz',
  'Pioneer',
];

export default function LogoCloud() {
  // duplicate so the marquee tiles seamlessly
  const track = [...brands, ...brands];

  return (
    <section className="relative bg-background text-foreground py-16 md:py-20 border-t border-border overflow-hidden">
      <div className="px-8 md:px-28">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-xs md:text-sm uppercase tracking-[0.18em] text-muted-foreground mb-10"
        >
          Trusted by 500+ ambitious brands worldwide
        </motion.p>
      </div>

      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-background to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-background to-transparent z-10" />

      {/* Framer Motion infinite right-to-left marquee */}
      <div className="relative w-full overflow-hidden">
        <motion.div
          className="flex w-max gap-14 md:gap-20 px-7 md:px-10 will-change-transform"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            duration: 30,
            ease: 'linear',
            repeat: Infinity,
          }}
        >
          {track.map((b, i) => (
            <span
              key={`${b}-${i}`}
              className="shrink-0 text-2xl md:text-3xl font-serif italic text-white/55 hover:text-white/90 transition-colors whitespace-nowrap"
            >
              {b}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
